import { StrictLocalizeFunction } from "@faire/web/common/localization";

export const SYNTHETIC_BRAND_VACATION_TOKEN = "mm_brand_vacation";
export const SYNTHETIC_SUPPORT_TOKEN = "mm_support_text";
export const SYNTHETIC_OTHER_PARTY_STATUS_TOKEN = "mm_other_party_status";

export const SYNTHETIC_MESSAGE_TOKENS = [
  SYNTHETIC_BRAND_VACATION_TOKEN,
  SYNTHETIC_SUPPORT_TOKEN,
  SYNTHETIC_OTHER_PARTY_STATUS_TOKEN,
];

export const SYNTHETIC_SUPPORT_MESSAGE = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    id: "MdHyYY",
    defaultMessage:
      "Have a question about Faire? We're online from 10am-3pm PST, Monday through Friday.",
    description: {
      text: "Message indicating Faire's Support hours of operation, which are 10am-3pm PST, Monday through Friday",
    },
  });

export const MAX_IMAGE_SIZE = 10 * 1024 * 1024;
